/** Подпись автомобиля для сообщений и скринридера: марка, модель, модификация. */
export function vehicleLabel(item: {
  make: string;
  model: string;
  variant: string | null;
}): string {
  return [item.make, item.model, item.variant].filter(Boolean).join(' ');
}
